import * as React from 'react';
import { l } from '../../Other/Translation';
import { Input } from '../common/Input/Input';
import { Modal } from '../common/Modal/Modal';
import { Button, ButtonType } from '../common/Button/Button';
import ImageInput from '../common/ImageInput/ImageInput';
import { toScaledBase64 } from '../../Other/ImageScale';

const addLogoImage = require('../../Static/images/add_logo.svg');

export interface CompanyModalInterface {
  companyName?: string;
  businessId?: string;
  vatNumber?: string;
  legalStatus?: string;
  tradeRegisterId?: string;
  streetAddress1?: string;
  streetAddress2?: string;
  zipCode?: string;
  city?: string;
  firstName?: string;
  lastName?: string;
  mobile?: string;
  phone?: string;
  logo?: string;
}

enum Fields {
  COMPANYNAME = 'companyName',
  BUSINESSID = 'businessId',
  VATNUMBER = 'vatNumber',
  LEGALSTATUS = 'legalStatus',
  TRADEREGISTERID = 'tradeRegisterId',
  STREETADDRESS1 = 'streetAddress1',
  STREETADDRESS2 = 'streetAddress2',
  ZIPCODE = 'zipCode',
  CITY = 'city',
  FIRSTNAME = 'firstName',
  LASTNAME = 'lastName',
  MOBILE = 'mobile',
  PHONE = 'phone'
}

export interface CompanyModalProps {
  isOpen: boolean;
  company?: CompanyModalInterface;
  save: (company: CompanyModalInterface) => void;
  close: () => void;
}

interface StateProps {
  company?: CompanyModalInterface;
}

export class CompanyModal extends React.Component<CompanyModalProps, StateProps> {

  constructor(props) {
    super(props);
    this.state = {
      company: props.company
    };
  }

  private renderInput(field, label, placeholder = ''): JSX.Element {
    const value = this.state.company[field] || '';
    return (
      <Input label={label !== '' ? l(label) : ''}
        value={value}
        automation={'companyModal-field-' + field}
        onBlur={(newValue) => {
          this.setState({ company: { ...this.state.company, [field]: newValue } });
        }}
        placeHolder={placeholder}
      />);
  }

  public render(): JSX.Element {
    return (
      <Modal
        isOpen={this.props.isOpen}
        automation={'companyModal'}
        header={l('invoiceGenerator.companyModal.header')}
        size={'medium'}
        showCloseIcon={true}
        onClose={() => this.props.close()}
        className={'CompanyModal'}
      >
        <div className={'form'}>
          <h2>{l('companyModal.companyInfo')}</h2>
          <ImageInput
            label={l('Logo')}
            imageDataUrl={this.state.company.logo || addLogoImage}
            allowDeletion={this.state.company.logo && true}
            uploadImage={async (imageData) =>
              this.setState({ company: { ...this.state.company, logo: await toScaledBase64(imageData, 180) } })}
            loading={false}
            onDelete={() => {
              this.setState({ company: { ...this.state.company, logo: null } });
            }}
          />
          {this.renderInput(Fields.COMPANYNAME, 'CompanyName')}
          {this.renderInput(Fields.BUSINESSID, 'BusinessId', l('input.placeholder.BusinessId'))}
          {this.renderInput(Fields.VATNUMBER, 'company.VatNumber', l('input.placeholder.VATNumber'))}
          {this.renderInput(Fields.LEGALSTATUS, 'legalStatus')}
          {this.renderInput(Fields.TRADEREGISTERID, 'tradeRegisterId')}
          <h2>{l('Address')}</h2>
          {this.renderInput(Fields.STREETADDRESS1, 'Address')}
          {this.renderInput(Fields.STREETADDRESS2, '')}
          {this.renderInput(Fields.ZIPCODE, 'PostalCode')}
          {this.renderInput(Fields.CITY, 'Municipality')}
          <h2>{l('contact')}</h2>
          {this.renderInput(Fields.FIRSTNAME, 'companyModal.firstName')}
          {this.renderInput(Fields.LASTNAME, 'companyModal.lastName')}
          {this.renderInput(Fields.MOBILE, 'companyModal.mobile')}
          {this.renderInput(Fields.PHONE, 'companyModal.phone')}
        </div>

        <footer>
          <Button
            label={l('Save')}
            type={ButtonType.normal}
            action={() => {
              this.props.save(this.state.company);
              this.props.close();
            }}
            automation="company-form-save"
          />
          <Button
            label={l('Cancel')}
            type={ButtonType.cancel}
            action={() => {
              this.props.close();
            }}
            automation="company-form-cancel"
          />
        </footer>
      </Modal>
    );
  }
}
